import React, { useState } from 'react';
import { Form, Tooltip, Row, Col, Table, Checkbox, Typography, InputNumber } from "antd";
import { FullHeightContainerLayout, BusinessAreaConnectionChangedAttributes } from "components";
import moment from 'moment';
import _ from 'lodash';

const { Column } = Table;
const { Title, Text, Link } = Typography;

const BusinessAreaSystemConnectionHistoryList = ({ businessAreaConnectionRevisions }) => {
    const [recordDetail, setRecordDetail] = useState(null);
    const [containerHeight, setContainerHeight] = useState("100%");
    return (
        <Row style={{ flexDirection: "column", flexGrow: 1, height: "100%" }}>
            <Col span={24} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <Row style={{ flexDirection: "column", flexGrow: 1, height: containerHeight }}>
                    <Col span={24}>
                        <FullHeightContainerLayout
                            content={<Table size="small"
                                rowKey="data.systemConnection.connectionId"
                                dataSource={businessAreaConnectionRevisions}
                                pagination={false}
                                scroll={{ y: `100vh` }}
                                className={"container-height-100"}>
                                <Column
                                    width="5rem"
                                    title="No."
                                    key="index"
                                    render={(value, businessAreaConnectionRevision, index) => index + 1}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "systemConnection", "name"]}
                                    title={"Connection"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, businessAreaConnectionRevision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "systemConnection", "type"]}
                                    title={"Credential Id"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, businessAreaConnectionRevision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="5rem"
                                    title={"Active"}
                                    dataIndex={["data", "systemConnection", "active"]}
                                    render={(value, businessAreaConnectionRevision, index) => <Checkbox disabled={true} checked={value}></Checkbox>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "createdByEmail"]}
                                    title={"Created By"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, businessAreaConnectionRevision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "createdDate"]}
                                    title={"Created Date"}
                                    render={(value, businessAreaConnectionRevision, index) => <>{moment.utc(value).toDate().toLocaleString()}</>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "updatedByEmail"]}
                                    title={"Updated By"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, businessAreaConnectionRevision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "updatedDate"]}
                                    title={"Updated Date"}
                                    render={(value, businessAreaConnectionRevision, index) => <>{moment.utc(value).toDate().toLocaleString()}</>}
                                />
                                <Column
                                    width="12rem"
                                    dataIndex={"changes"}
                                    title={"Changes"}
                                    render={(value, businessAreaConnectionRevision, index) => {
                                        if (value) {
                                            return <>
                                                {Object.keys(value).reduce((items, key) => {
                                                    if (Object.keys(value[key]).length > 0) {
                                                        items.push(<Row key={key}>
                                                            <Col>
                                                                <Link onClick={() => {
                                                                    setContainerHeight("50%");
                                                                    setRecordDetail({
                                                                        name: `${_.capitalize(key)} attributes`,
                                                                        recordId: businessAreaConnectionRevision.data.systemConnection.connectionId,
                                                                        data: value[key],
                                                                        previousData: businessAreaConnectionRevision.previousChanges && businessAreaConnectionRevision.previousChanges[key]
                                                                    });
                                                                }}>
                                                                    {`${key} attributes`}
                                                                </Link>
                                                            </Col>
                                                        </Row>);
                                                    }
                                                    return items;
                                                }, [])}
                                            </>
                                        }
                                        return <></>;
                                    }}
                                />
                            </Table>}>
                        </FullHeightContainerLayout>
                    </Col>
                </Row>
                {
                    recordDetail
                        ?
                        <Row style={{ flexDirection: "column", flexGrow: 1, height: containerHeight }}>
                            <Col span={24}>
                                <FullHeightContainerLayout
                                    showHeader={false}
                                    content={<BusinessAreaConnectionChangedAttributes key={recordDetail.recordId} record={recordDetail}></BusinessAreaConnectionChangedAttributes>}
                                    showFooter={false}>
                                </FullHeightContainerLayout>
                            </Col>
                        </Row>
                        :
                        <></>}
            </Col>
        </Row>
    );
}

export default BusinessAreaSystemConnectionHistoryList;